import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import Util from "@/Master/Util";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import {comRequest} from "@/Fwk/Http/comRequest";
import {NetType} from "@/Fwk/Http/NetType";

export default class RewardApply {
    public static tag = '[Reward]'
    public static Instance = new RewardApply();
    private isRequesting: boolean = false;
    public async RequestRewardApply(rewardSource: number,onFinish: (data: HttpResponse<any>)=>void) {
        if (this.isRequesting) return;
        let requestData = {} as RequestRewardApplyData;
        requestData.rewardSource = rewardSource
        requestData.userId = LoginUIManager.getLastUserId+'';
        if (Util.isLog) {
            console.log(RewardApply.tag, requestData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RewardApply),
            method: 'POST',
            body: requestData,
        };
        const response = await this.DoSendRequest<any>(config);
        onFinish(response);
    }
    public async RequestRewardConfig(rewardSource: number,onFinish: (data: HttpResponse<ResponseRewardConfig>)=>void) {
        if (this.isRequesting) return;
        let requestData = {} as RequestRewardApplyData;
        requestData.rewardSource = rewardSource
        requestData.userId = LoginUIManager.getLastUserId+'';
        if (Util.isLog) {
            console.log(RewardApply.tag, requestData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RewardConfig),
            method: 'POST',
            body: requestData,
        };
        const response = await this.DoSendRequest<ResponseRewardConfig>(config);
        onFinish(response);
    }
    public async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this.isRequesting = true;
        config.isSerErrTips = true;
        const sendRequest = await comRequest<T>(config);
        this.isRequesting = false;
        return sendRequest;
    }
}
